import styled from 'styled-components';

const SimpleButton = styled.button`
  outline: none;
  border: none;
  border-radius: 4px;
  padding: 8px 32px;
  cursor: pointer;
  font-weight: 700;
  font-size: 17px;
  line-height: 20px;
  transition: background-color 0.3s;
`;

export const PrimaryButton = styled(SimpleButton)`
  color: white;
  background-color: #519A71;
  &:hover {
    background-color: #519A71E6;
  }
`;

export const SecondaryButton = styled(SimpleButton)`
  color: #949494;
  background-color: #F5F5F5;
`;

export const OutlinedButton = styled(SimpleButton)`
  color: #519A71;
  background-color: white;
  border: 1px solid #519A71;
  &:hover {
    background-color: #519A710D;
  }
`;

export const DangerButton = styled(SimpleButton)`
  color: white;
  background-color: #EB4D3D;
`;
